// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"BookSupplierPrincipals__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/BookSupplierPrincipals/BookSupplierPrincipals.scss
 ** module id = 893
 ** module chunks = 1
 **/